import { Reducer } from "redux";

import { MasterDisciplineResponse } from "../models/api/Master";
import { MasterDisciplineDispatchTypes } from "../models/dispatchTypes/Master";
import { MasterDisciplineActionDispatchTypes } from "../constants/Master";

export const initialState: MasterDisciplineResponse = {
  loading: false,
  response: [],
  error: null
};

const MasterDisciplineReducer: Reducer<
MasterDisciplineResponse,
MasterDisciplineDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case MasterDisciplineActionDispatchTypes.MASTER_DISCIPLINE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case MasterDisciplineActionDispatchTypes.MASTER_DISCIPLINE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case MasterDisciplineActionDispatchTypes.MASTER_DISCIPLINE_ERRORS: {
      return initialState;
    }
  }
  return state;
};

export default MasterDisciplineReducer;
